import { AuthCheckerModel } from './AuthChecker.model';

/**
 * Auth Checker Viewer Component
 *
 * Purpose: Display a loading indicator while checking authentication state
 *
 * Behavior:
 * - Shows a loading indicator if isChecking is true
 * - Returns null if isChecking is false
 */
export const AuthCheckViewer: React.FC<AuthCheckerModel> = ({ isChecking }) => {
  /**
   * Show loading while checking (brief moment before redirect)
   */
  if (isChecking) {
    return (
      <div className='auth-checker-loading' role='status' aria-label='Checking authentication'>
        <span> </span>
      </div>
    );
  }
  // If we reach here, either token is valid or there was an error
  // In both cases, don't render anything
  return null;
};

export default AuthCheckViewer;
